import PropsDivider from '@hlibs/react-web/props-divider';

export default PropsDivider;